import { render } from "./QRCodeVue3.vue?vue&type=template&id=1edcaff8"
import script from "./QRCodeVue3.vue?vue&type=script&lang=ts"
export * from "./QRCodeVue3.vue?vue&type=script&lang=ts"
script.render = render

export default script